import React from "react";
import { Link } from "react-router-dom";

import currentStudiesData from "../../data/current-studies.json";

const FeaturesTwo = () => {
  return (
    <>
      <section id="features" className="feature-section ptb-100">
        {currentStudiesData.studies.map((study) => (
          <div key={study.id} className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-4">
                <div className="download-img">
                  <Link to={`/current-studies/${study.id}`}>
                    <img
                      src={require(`../../images/current-studies/${study.image}`)}
                      className="img-fluid"
                      style={{ borderRadius: "10px" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-md-8">
                <div className="feature-contents section-heading">
                  <Link to={`/current-studies/${study.id}`}>
                    <h2>{study.title}</h2>
                  </Link>
                  <p style={{ fontSize: "1.2rem" }}>{study.description}</p>

                  <div className="mt-3">
                    <h5>You may qualify if you: </h5>
                    {study.qualification.map((val, index) => (
                      <p style={{ fontSize: "1.2rem" }} key={index}>
                        {val}
                      </p>
                    ))}
                  </div>

                  <div className="mt-3">
                    <h5>As a participant, you will receive: </h5>
                    {study.awards.map((val, index) => (
                      <p style={{ fontSize: "1.2rem" }} key={index}>
                        {val}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="post-more pt-4 align-items-center justify-content-center d-flex">
              <Link
                to={`/current-studies/${study.id}`}
                className="btn solid-btn"
              >
                More Details <span className="ti-arrow-right"></span>
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default FeaturesTwo;
